import React, { forwardRef } from "react"
import PropTypes from "prop-types"
import cn from "classnames"

import styles from "./appbar-base.module.css"

export const BaseAppbar = forwardRef(
  ({ children, bezel = true, ...props }, ref) => {
    // filtering out style and className
    /* eslint-disable-next-line react/prop-types */
    const { style, className, ...rest } = props

    return (
      <div
        {...rest}
        className={cn(styles.BaseAppbar, { [styles.bezelless]: !bezel })}
        ref={ref}
      >
        {children}
      </div>
    )
  }
)

BaseAppbar.displayName = "BaseAppbar"

BaseAppbar.propTypes = {
  /**
   * Container for the BaseAppbar content.
   */
  children: PropTypes.node.isRequired,
  /**
   * Adds padding.
   */
  bezel: PropTypes.bool,
}

BaseAppbar.defaultProps = {
  bezel: true,
}
